import { Block, BlockTitle, Icon, Link, Popover } from "framework7-react";
import { useId } from "react";

import { useCategoryKeys } from "@/hooks/useCategoryKeys";
import legendToggleFeelingImg from "@/images/legend-toggle-feeling.png";

import { CategoryChip } from "./CategoryChip";
import { LegendBar } from "./LegendBar";
import { LegendToggleButton } from "./LegendToggleButton";

export function CategoryLegendBar() {
  const categoryKeys = useCategoryKeys();
  const PopoverId = useId();

  return (
    <LegendBar>
      <div style={{ display: "flex", overflow: "hidden", whiteSpace: "nowrap" }}>
        {categoryKeys.map((categoryKey) => (
          <CategoryChip
            key={categoryKey}
            categoryKey={categoryKey}
          />
        ))}
      </div>
      <div
        style={{
          alignItems: "center",
          display: "flex",
          gap: "1rem",
          paddingLeft: "1rem",
        }}
      >
        <Link
          popoverOpen={`.popover-${PopoverId}`}
          style={{ display: "inline-block" }}
        >
          <Icon
            material="more_horiz"
            slot="media"
          />
        </Link>
        <Popover className={`popover-${PopoverId}`}>
          <BlockTitle>カテゴリー</BlockTitle>
          <Block>
            {categoryKeys.map((categoryKey) => (
              <CategoryChip
                key={categoryKey}
                categoryKey={categoryKey}
              />
            ))}
          </Block>
        </Popover>
        <LegendToggleButton src={legendToggleFeelingImg} />
      </div>
    </LegendBar>
  );
}
